export default "__VITE_ASSET__874d7f99__"